import { darken, rgba } from 'polished';
import { PropsWithChildren, useMemo } from 'react';
import { ThemeProvider } from 'styled-components';
import { IAppTheme } from 'types/AppTheme';
import { useGetPortalSettingsQuery } from 'slices';
import { cssVariables } from './variables';
import { DEFAULT_THEME, HOVER_DARKEN, HOVER_OPACITY } from './constants';
import { GlobalThemeVariables } from 'theme/GlobalThemeVariables';

const ThemeProviderProxy = ThemeProvider as any;

export const AppTheme = ({ children }: PropsWithChildren<{}>) => {
  const { currentData: settings } = useGetPortalSettingsQuery();

  const theme = useMemo<IAppTheme>(() => {
    const accentColor = settings?.branding?.accentColor;
    const brandColor = settings?.branding?.brandColor;

    if (!accentColor || !brandColor) {
      return DEFAULT_THEME;
    }

    return {
      cssVariables,
      colors: {
        ...DEFAULT_THEME.colors,
        accentColor,
        brandColor,
        textBrandColor: settings.branding.brandFontColor,
        textAccentColor: settings.branding.accentFontColor,

        hoverBrandColor: darken(HOVER_DARKEN, brandColor),
        hoverAccentColor: darken(HOVER_DARKEN, accentColor),
        backgroundHoverAccentColor: rgba(accentColor, HOVER_OPACITY),
        backgroundHoverBrandColor: rgba(brandColor, HOVER_OPACITY),
      },
    };
  }, [settings]);

  return (
    <ThemeProviderProxy theme={theme}>
      <GlobalThemeVariables />
      {children}
    </ThemeProviderProxy>
  );
};
